import Input from './input.element.js';

export default Input;

Input.define('wje-input', Input);
